import type { PropsWithChildren } from 'react'
import { createGlobalStyle, ThemeProvider } from 'styled-components'
import type { Brand } from '@velasca/types'
import { getThemeByBrand } from '@velasca/utils/get-theme-by-brand'

const GlobalStyle = createGlobalStyle`
  :root{
    ${({ theme }) => `
        --theme-primary-color: ${theme.colors.primary};
        --theme-primary-light: ${theme.colors.primaryLight};
        --theme-primary-hover: ${theme.colors.hover};
        --theme-secondary-color: ${theme.colors.secondary};
        --theme-light-color: ${theme.colors.boxBackground};
        --theme-primary-text-color: ${theme.colors.text.primary};
        --theme-secondary-text-color:  ${theme.colors.text.secondary};
        --theme-border-color: ${theme.colors.border};
        --theme-font-family: ${theme.fonts.brand};
        --theme-secondary-font-family: ${theme.fonts.serif.fontFamily};

        #stamped-main-widget .react-loading-skeleton {
          --base-color: ${theme.colors.skeleton.baseColor};
          --highlight-color: ${theme.colors.skeleton.highlightColor};
        }
      `}
  }
`

interface CustomThemeProviderProps extends PropsWithChildren {
  themeID?: Brand
}

export const CustomThemeProvider = ({ children }: CustomThemeProviderProps) => {
  return (
    <ThemeProvider theme={getThemeByBrand()}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  )
}
